import { CustomAttributeTypeDTO } from '@/modules/common/types/dto/response/custom-attribute-response';

/**
 * What a report dimension describes — mirrors the backend `ReportDimensionEntity`
 * (returned per dimension in `GET /reports/columns`). The field picker groups dimensions by it.
 */
export enum ReportDimensionEntityDTO {
  MEMBER = 'MEMBER',
  PROJECT = 'PROJECT',
  CLIENT = 'CLIENT',
  TIME_OFF = 'TIME_OFF',
  OVERHEAD = 'OVERHEAD',
  TIME = 'TIME',
}

/** Where a dimension comes from — mirrors the backend `ReportDimensionSource`. */
export enum ReportDimensionSourceDTO {
  BUILT_IN = 'BUILT_IN',
  CUSTOM_ATTRIBUTE = 'CUSTOM_ATTRIBUTE',
}

export interface ReportDimensionResponse {
  key: string;
  label: string;
  entity: ReportDimensionEntityDTO;
  source: ReportDimensionSourceDTO;
  /** The attribute's value type when `source` is a custom attribute, otherwise null. */
  customAttributeType: CustomAttributeTypeDTO | null;
  idKey: string;
  displayKey: string;
  description: string | null;
}
